var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "handle-document view" },
    [
      _vm.isE2EFlow
        ? _c(
            "div",
            { staticClass: "view_top" },
            [
              _c("ma-navbar-stepper", {
                attrs: { numberOfStep: 3, textOfStep: _vm.$t("stepper.step3") },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "view_content" },
        [
          _c("transition", { attrs: { mode: "out-in" } }, [
            _vm.getFlowName === "billma_bpce"
              ? _c("div", { staticClass: "view_content_markdown" }, [
                  _c("h1", [_vm._v(_vm._s(_vm.$t("documentContainer.title")))]),
                  _c("p", [_vm._v(_vm._s(_vm.$t("documentContainer.upper1")))]),
                  _c("p", [_vm._v(_vm._s(_vm.$t("documentContainer.upper2")))]),
                  _c("p", [_vm._v(_vm._s(_vm.$t("documentContainer.upper3")))]),
                  _c("p", [_vm._v(_vm._s(_vm.$t("documentContainer.upper4")))]),
                  _c(
                    "div",
                    { staticClass: "handle-document__wrapper" },
                    [
                      _vm.handleDocumentStepActive === "uploadDocuments"
                        ? _c("ma-upload-document", {
                            attrs: {
                              documents: _vm.mappedDocuments,
                              loading: _vm.uploadLoading,
                              disableActions: _vm.icrLoading,
                            },
                            on: {
                              onDocumentInputChange: function ($event) {
                                return _vm.handleDocumentInputChange($event)
                              },
                              onDocumentDeleteClick: function ($event) {
                                return _vm.handleDocumentDeleteClick($event)
                              },
                              onDocumentDownloadClick: function ($event) {
                                return _vm.handleDocumentDownloadClick($event)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("p", { staticClass: "blueDark text-small mg mg--t-2" }, [
                    _vm._v("Joindre le fichier au format .pdf, .jpeg ou .png"),
                  ]),
                ])
              : _c("div", { staticClass: "view_content_markdown" }, [
                  _c("h1", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "document.handleDocumentContainer.billmaSolution.title"
                        )
                      )
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "document.handleDocumentContainer.billmaSolution.solution"
                        )
                      )
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "document.handleDocumentContainer.billmaSolution.text1"
                        )
                      )
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "document.handleDocumentContainer.billmaSolution.text2"
                        )
                      )
                    ),
                  ]),
                  _c("p", { staticClass: "text-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "document.handleDocumentContainer.billmaSolution.text3"
                        )
                      )
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "handle-document__wrapper" },
                    [
                      _vm.handleDocumentStepActive === "uploadDocuments"
                        ? _c("ma-upload-document", {
                            attrs: {
                              "btn-text": _vm.$t(
                                "document.handleDocumentContainer.billmaSolution.uploadBtn"
                              ),
                              documents: _vm.mappedDocuments,
                              loading: _vm.uploadLoading,
                              disableActions: _vm.icrLoading,
                            },
                            on: {
                              onDocumentInputChange: function ($event) {
                                return _vm.handleDocumentInputChange($event)
                              },
                              onDocumentDeleteClick: function ($event) {
                                return _vm.handleDocumentDeleteClick($event)
                              },
                              onDocumentDownloadClick: function ($event) {
                                return _vm.handleDocumentDownloadClick($event)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("p", { staticClass: "blueDark text-small mg mg--t-2" }, [
                    _vm._v("Joindre le fichier au format .pdf, .jpeg ou .png"),
                  ]),
                ]),
          ]),
          _vm.deleteError
            ? _c("p", { staticClass: "errorMsg text-small red mg mg--t-1" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("document.handleDocumentContainer.deleteModal.error")
                  )
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "view_content_buttons" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn mainBlue mg handle-document-btn mg--r-2 mg--b-2",
                style: {
                  background: _vm.getFlowCompanyColor,
                  borderColor: _vm.getFlowCompanyColor,
                },
                attrs: { disabled: _vm.primaryButtonIsDisabled },
                on: { click: _vm.handlePrimaryButtonClick },
              },
              [_vm._v("Continuer")]
            ),
            _vm.isE2EFlow
              ? _c(
                  "button",
                  {
                    staticClass: "btn mainWhite backBtn",
                    on: { click: _vm.handleSecondaryButtonClick },
                  },
                  [
                    _c("p", { staticClass: "text-medium" }, [
                      _vm._v("Je souhaite être rappelé(e)"),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.isE2EFlow
              ? _c(
                  "button",
                  {
                    staticClass: "ternaryWhite center mg mg--t-2",
                    on: { click: _vm.handleTertiaryButtonClick },
                  },
                  [
                    _c("p", { staticClass: "text-medium" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "document.handleDocumentContainer.actions.tertiary"
                          )
                        )
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _c(
        "ma-modal",
        {
          ref: "icrProcessingModal",
          staticClass: "handle-document_icr-modal",
          attrs: { type: "full", closeIsHidden: "" },
        },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "view" }, [
              _c(
                "div",
                { staticClass: "view_content" },
                [
                  _vm.icrProcessingModalTextActive === "one"
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "handle-document_icr-modal_title text-medium gray mg mg--b-14 center",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "document.handleDocumentContainer.icrModal.title"
                              )
                            )
                          ),
                        ]
                      )
                    : _c(
                        "p",
                        {
                          staticClass:
                            "handle-document_icr-modal_title text-medium gray mg mg--b-14 center",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "document.handleDocumentContainer.icrModal.title2"
                              )
                            )
                          ),
                        ]
                      ),
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _vm.icrProcessingModalTextActive === "one"
                        ? _c("div", { key: "one" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-medium gray mg mg--b-4 center",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "document.handleDocumentContainer.icrModal.text1"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ])
                        : _c("div", { key: "two" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-medium gray mg mg--b-4 center",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "document.handleDocumentContainer.icrModal.text3"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]),
                    ]
                  ),
                  _c("ma-spinner", { attrs: { size: "large" } }),
                ],
                1
              ),
            ]),
          ]),
        ],
        2
      ),
      _c(
        "ma-modal",
        {
          ref: "deleteDocumentModal",
          staticClass: "modal-confirmation delete-document-modal",
          attrs: { type: "small", "close-is-hidden": "" },
        },
        [
          _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              { staticClass: "modal__main" },
              [
                _c("p", { staticClass: "gray headline-large mg mg--b-3" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "document.handleDocumentContainer.deleteModal.title"
                      )
                    )
                  ),
                ]),
                _c("p", { staticClass: "gray text-medium-large mg mg--b-5" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "document.handleDocumentContainer.deleteModal.text",
                        { name: _vm.documentToDeleteName }
                      )
                    )
                  ),
                ]),
                _c("ma-actions-buttons", {
                  staticClass: "delete-document-modal_actions",
                  attrs: {
                    handleButtonClick: _vm.confirmDeleteDocument,
                    handleButtonClickWhiteBtn: _vm.closeDeleteDocumentModal,
                    title: _vm.$t(
                      "document.handleDocumentContainer.deleteModal.confirm"
                    ),
                    titleWhiteBtn: _vm.$t(
                      "document.handleDocumentContainer.deleteModal.cancel"
                    ),
                    shouldBeDisabled: _vm.deleteLoading,
                    btnType: "functionalBtnWhite",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "ma-modal",
        {
          ref: "modalCookiesAndLegal",
          staticClass: "modal-confirmation",
          attrs: { type: "initial", "close-is-hidden": "" },
        },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "modal__main" }, [
              _vm.showGeneralValue
                ? _c(
                    "div",
                    { staticClass: "general" },
                    [
                      _c("h2", { staticClass: "title-legal" }, [
                        _vm._v(
                          _vm._s(_vm.$t("cookiesAndLegal.bpce.general.title"))
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.bpce.general.paragraph1")
                          )
                        ),
                      ]),
                      _c("h2", { staticClass: "title-legal" }, [
                        _vm._v(
                          _vm._s(_vm.$t("cookiesAndLegal.bpce.general.title2"))
                        ),
                      ]),
                      _c("span", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.bpce.general.paragraph2")
                          )
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "text-link d-inline",
                            on: { click: _vm.showPrivacyPolicy },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.bpce.general.policyText"
                                )
                              )
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "checkbox-container" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isChecked,
                              expression: "isChecked",
                            },
                          ],
                          staticClass: "checkbox",
                          attrs: { type: "checkbox", id: "privacy-checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.isChecked)
                              ? _vm._i(_vm.isChecked, null) > -1
                              : _vm.isChecked,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.isChecked,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.isChecked = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.isChecked = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.isChecked = $$c
                              }
                            },
                          },
                        }),
                        _c(
                          "label",
                          {
                            staticClass: "main-paragraph privacy-text",
                            attrs: { for: "privacy-checkbox" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.bpce.general.acceptText"
                                )
                              )
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "text-link",
                                on: { click: _vm.showPrivacyPolicy },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "cookiesAndLegal.bpce.general.privacyText"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "info-container" },
                        [
                          _c("svgicon", {
                            staticClass: "svg-icon-action close-icon",
                            attrs: { icon: "ico-info", height: "20" },
                            on: { click: _vm.goToPrivacy },
                          }),
                          _c(
                            "a",
                            {
                              staticClass: "text-link",
                              on: { click: _vm.goToPrivacy },
                            },
                            [_vm._v("Consulter les mentions légales")]
                          ),
                        ],
                        1
                      ),
                      _c("ma-actions-buttons", {
                        attrs: {
                          "should-be-disabled": !_vm.isChecked,
                          handleButtonClick: _vm.closeModal,
                          title: _vm.$t("actions.accept"),
                          btnType: "non-fixedBtn",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showPrivacy
                ? _c(
                    "div",
                    { staticClass: "privacy" },
                    [
                      _c(
                        "div",
                        { staticClass: "close-container" },
                        [
                          _c("svgicon", {
                            staticClass: "svg-icon-action close-icon",
                            attrs: { icon: "delete", height: "18" },
                            on: { click: _vm.hidePrivacyPolicy },
                          }),
                        ],
                        1
                      ),
                      _c("h2", { staticClass: "privacy-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("cookiesAndLegal.bpce.privacy.title"))
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.bpce.privacy.paragraph1")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.bpce.privacy.paragraph2")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.bpce.privacy.paragraph3")
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "main-paragraph d-inline" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.bpce.privacy.paragraph4")
                          )
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "text-link d-inline",
                            attrs: {
                              href: "mailto:dpd@multiasistencia.com",
                              target: "_blank",
                            },
                          },
                          [_vm._v("dpd@multiasistencia.com")]
                        ),
                        _c("p", { staticClass: "main-paragraph d-inline" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.bpce.privacy.paragraph5")
                            )
                          ),
                        ]),
                        _c(
                          "a",
                          {
                            staticClass: "text-link d-inline",
                            attrs: {
                              href: "https://www.cnil.fr",
                              target: "_blank",
                            },
                          },
                          [_vm._v("https://www.cnil.fr")]
                        ),
                        _c("p", { staticClass: "main-paragraph d-inline" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.bpce.privacy.paragraph6")
                            )
                          ),
                        ]),
                        _c(
                          "a",
                          {
                            staticClass: "text-link d-inline",
                            attrs: {
                              href: "mailto:dpd@multiasistencia.com",
                              target: "_blank",
                            },
                          },
                          [_vm._v("dpd@multiasistencia.com")]
                        ),
                        _c("p", { staticClass: "main-paragraph d-inline" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.bpce.privacy.paragraph7")
                            )
                          ),
                        ]),
                      ]),
                      _c("ma-actions-buttons", {
                        staticClass: "privacy-btn",
                        attrs: {
                          handleButtonClick: _vm.hidePrivacyPolicy,
                          title: _vm.$t("actions.continue"),
                          btnType: "non-fixedBtn",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }